module.exports = __webpack_public_path__ + "img/16_8.b8a4d1a3.png";